<div class="blur-background"
    [ngClass]="{
        'loading-screen d-flex flex-column justify-content-center align-items-center text-light h-100 w-100 rounded-2': true,
        'border border-success': true
    }"
>
    <div class="w-100">
        <div class="progress progress-bar-step">
            <div
                class="progress-bar bg-info"
                role="progressbar"
                [style.width.%]="progress"
                [attr.aria-valuenow]="progress"
                aria-valuemin="0"
                aria-valuemax="100"
            ></div>
        </div>
        <p class="text-center mt-2 mb-0">{{ loadingMessage }}</p>
    </div>
</div>
